import loadJS from 'load-js';

import whenDomReady from 'when-dom-ready';

/**
 * Wait for DOM to be ready and load external JavaScript files.
 *
 * @example
 * // Start player after script is ready
 * preLoad({ ['path/to/script.js'] })
 *   .then(() => {
 *     hearstPlayer.start();
 *   })
 *   .catch(error => {
 *     console.error(error);
 *   });
 *
 * @param {Object} settings - Settings object.
 * @return {promise} Promise that resolves when DOM ready and scripts loaded.
 */
export function preLoad(scripts) {
  return Promise.all([loadJS(scripts), whenDomReady()]);
}

/**
 * Check if browser is Safari.
 * @param {Object} navigator - A Navigator instance.
 * @returns {bool}
 */
export function isBrowserSafari(navigator) {
  return (
    navigator.vendor &&
    navigator.vendor.indexOf('Apple') > -1 &&
    navigator.userAgent &&
    !navigator.userAgent.match('CriOS')
  );
}



// WEBPACK FOOTER //
// ./node_modules/video-js-core/src/utils.js